import { useState } from 'react';
import { Check, LockKeyhole } from 'lucide-react';
import { apiClient } from '@/lib/apiClient';
import './ChangePasswordForm.css';

const getErrorMessage = (error) => {
  const detail = error?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map((item) => item.msg).filter(Boolean).join('، ');
  }
  return 'تغییر رمز عبور با خطا مواجه شد.';
};

export default function ChangePasswordForm() {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSuccess('');

    if (newPassword.length < 8) {
      setError('رمز عبور جدید باید حداقل ۸ نویسه باشد.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('تکرار رمز عبور با رمز عبور جدید مطابقت ندارد.');
      return;
    }
    if (newPassword === currentPassword) {
      setError('رمز عبور جدید باید با رمز عبور فعلی متفاوت باشد.');
      return;
    }

    setSaving(true);
    try {
      const { error: requestError } = await apiClient.POST(
        '/api/v1/auth/change-password',
        { body: { current_password: currentPassword, new_password: newPassword } }
      );
      if (requestError) {
        setError(getErrorMessage(requestError));
        return;
      }

      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      setSuccess('رمز عبور با موفقیت تغییر کرد.');
    } catch {
      setError('تغییر رمز عبور با خطا مواجه شد.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <form className="change-password-form" onSubmit={handleSubmit} dir="rtl">
      <div className="change-password-heading">
        <h2><LockKeyhole size={17} /> تغییر رمز عبور</h2>
      </div>

      {error && <div className="change-password-message error" role="alert">{error}</div>}
      {success && (
        <div className="change-password-message success" role="status">
          <Check size={16} /> {success}
        </div>
      )}

      <div className="change-password-fields">
        <label>
          رمز عبور فعلی
          <input
            type="password"
            autoComplete="current-password"
            value={currentPassword}
            onChange={(event) => setCurrentPassword(event.target.value)}
            required
          />
        </label>
        <label>
          رمز عبور جدید
          <input
            type="password"
            autoComplete="new-password"
            minLength={8}
            value={newPassword}
            onChange={(event) => setNewPassword(event.target.value)}
            required
          />
        </label>
        <label>
          تکرار رمز عبور جدید
          <input
            type="password"
            autoComplete="new-password"
            minLength={8}
            value={confirmPassword}
            onChange={(event) => setConfirmPassword(event.target.value)}
            required
          />
        </label>
      </div>

      <button className="change-password-submit" type="submit" disabled={saving}>
        {saving ? 'در حال ذخیره...' : 'تغییر رمز عبور'}
      </button>
    </form>
  );
}
